class BestSellersSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    const root = this.closest('.best-sellers');
    this.prevBtn = root ? root.querySelector('[data-prev]') : null;
    this.nextBtn = root ? root.querySelector('[data-next]') : null;

    if (!this.track) return;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByAmount(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByAmount(1));

    this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
    window.addEventListener('resize', () => this.updateArrows());
    this.updateArrows();
  }

  scrollByAmount(direction) {
    if (!this.track) return;
    const delta = this.track.clientWidth * 0.85 * direction;
    this.track.scrollBy({ left: delta, behavior: 'smooth' });
  }

  updateArrows() {
    if (!this.track) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
    const atStart = this.track.scrollLeft <= 0;
    const atEnd = this.track.scrollLeft >= maxScroll;

    if (this.prevBtn) {
      this.prevBtn.disabled = atStart;
      this.prevBtn.classList.toggle('is-disabled', atStart);
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = atEnd;
      this.nextBtn.classList.toggle('is-disabled', atEnd);
    }
  }
}

if (!customElements.get('best-sellers-slider')) {
  customElements.define('best-sellers-slider', BestSellersSlider);
}

(function () {
  const WISHLIST_KEY = 'woodova:wishlist';

  function getWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(ids) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    } catch (e) {
      /* localStorage unavailable — wishlist state just won't persist */
    }
  }

  function initWishlistButtons(root) {
    const scope = root || document;
    const wishlist = getWishlist();
    scope.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const id = btn.dataset.productId;
      const isActive = wishlist.indexOf(id) !== -1;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function toggleWishlist(btn) {
    const id = btn.dataset.productId;
    if (!id) return;

    const wishlist = getWishlist();
    const index = wishlist.indexOf(id);
    const willBeActive = index === -1;

    if (willBeActive) {
      wishlist.push(id);
    } else {
      wishlist.splice(index, 1);
    }

    setWishlist(wishlist);
    btn.classList.toggle('is-active', willBeActive);
    btn.setAttribute('aria-pressed', willBeActive ? 'true' : 'false');
  }

  function refreshCartBubble() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    fetch(`${window.location.pathname}?sections=cart-icon-bubble`)
      .then((res) => res.json())
      .then((data) => {
        const html = data['cart-icon-bubble'];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newBubble = doc.getElementById('cart-icon-bubble');
        if (newBubble) bubble.innerHTML = newBubble.innerHTML;
      })
      .catch(() => {});
  }

  function handleQuickAdd(btn) {
    if (btn.classList.contains('is-loading')) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const label = btn.querySelector('[data-quick-add-label]');
    const originalText = label ? label.textContent : '';

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          throw new Error(data.description || 'Unable to add to cart');
        }
        btn.classList.add('is-added');
        if (label) label.textContent = 'Added';
        refreshCartBubble();
        window.setTimeout(() => {
          btn.classList.remove('is-added');
          if (label) label.textContent = originalText;
        }, 1800);
      })
      .catch(() => {
        if (label) label.textContent = 'Try again';
        window.setTimeout(() => {
          if (label) label.textContent = originalText;
        }, 1800);
      })
      .finally(() => {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }

  document.addEventListener('click', (event) => {
    const wishlistBtn = event.target.closest('[data-wishlist-toggle]');
    if (wishlistBtn) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(wishlistBtn);
      return;
    }

    const quickAddBtn = event.target.closest('[data-quick-add]');
    if (quickAddBtn) {
      event.preventDefault();
      event.stopPropagation();
      handleQuickAdd(quickAddBtn);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWishlistButtons());
  } else {
    initWishlistButtons();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initWishlistButtons(event.target));
  }
})();
